function maskCurrency(value: string, currencySymbol: string = '$'): string {
  value = value
    .replace(/[^0-9]/g, '') // Remove unwanted characters and leave only numbers
    .replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add commas as separators every 3 digits
  return value !== '' ? `${currencySymbol}${value}` : value;
}

export { maskCurrency };
